import { apiClient } from "../config/api.config";
import { SearchRequest } from "../types/search.definition";

export function requestSearchDoctors(data: SearchRequest) {
  return apiClient.request({
    method: "POST",
    url: `/doctors/search`,
    data,
  });
}

export function requestSearchHealthFacilities(data: SearchRequest) {
  return apiClient.request({
    method: "POST",
    url: `/health-facilities/search`,
    data,
  });
}

export function searchPatientsInHealthcareFacility(
  data: SearchRequest,
  id: number
) {
  return apiClient.request({
    method: "post",
    url: `/healthcare-facilities/${id}/patients/search`,
    data,
  });
}
export function searchDoctorsInHealthcareFacility(
  data: SearchRequest,
  id: number
) {
  return apiClient.request({
    method: "post",
    url: `/healthcare-facilities/${id}/doctors/search`,
    data,
  });
}
export function searchAppointmentsInHealthcareFacility(
  data: SearchRequest,
  id: number
) {
  return apiClient.request({
    method: "post",
    url: `/healthcare-facilities/${id}/appointments/search`,
    data,
  });
}

export function searchStaff(data: SearchRequest, facilityId: number) {
  return apiClient.request({
    method: "POST",
    url: `/healthcare-facilities/${facilityId}/staff/search`,
    data,
  });
}

export function requestSearchSecretaries(data: SearchRequest) {
  return apiClient.request({
    method: "POST",
    url: `/secretaries/search`,
    data,
  });
}
